var map = {
	"./attachment-pin.svg": [
		13622,
		3622
	],
	"./back.svg": [
		13666,
		3666
	],
	"./book.svg": [
		13164,
		3164
	],
	"./calendar.svg": [
		20625,
		625
	],
	"./calender.svg": [
		39237,
		9237
	],
	"./change.svg": [
		56643,
		6643
	],
	"./checkbox.svg": [
		70412,
		412
	],
	"./checked.svg": [
		58774,
		8774
	],
	"./class-teacher.svg": [
		77052,
		7052
	],
	"./class.svg": [
		33425,
		3425
	],
	"./clock.svg": [
		34259,
		4259
	],
	"./close.svg": [
		71157,
		1157
	],
	"./completed-students.svg": [
		86911,
		6911
	],
	"./correct.svg": [
		83919,
		3919
	],
	"./delete-reward.svg": [
		2978,
		2978
	],
	"./delete.svg": [
		49226,
		9226
	],
	"./down-icon-dark.svg": [
		97884,
		7884
	],
	"./down.svg": [
		28723,
		8723
	],
	"./edit-pencil.svg": [
		61935,
		1935
	],
	"./edit.svg": [
		23687,
		3687
	],
	"./exclamation.svg": [
		84670,
		4670
	],
	"./faq.svg": [
		83277,
		3277
	],
	"./feedback.svg": [
		21538,
		1538
	],
	"./file-upload.svg": [
		58265,
		8265
	],
	"./filter.svg": [
		55481,
		5481
	],
	"./generate-report.svg": [
		90045,
		45
	],
	"./graduation-cap.svg": [
		47632,
		7632
	],
	"./grid-select.svg": [
		53952,
		3952
	],
	"./grid-unselect.svg": [
		93833,
		3833
	],
	"./left-arrow.svg": [
		41760,
		1760
	],
	"./list-select.svg": [
		71168,
		1168
	],
	"./list-unselect.svg": [
		76489,
		6489
	],
	"./logout.svg": [
		55005,
		5005
	],
	"./mail.svg": [
		87486,
		7486
	],
	"./menu.svg": [
		63546,
		3546
	],
	"./partial.svg": [
		6674,
		6674
	],
	"./plus.svg": [
		68483,
		8483
	],
	"./profile.svg": [
		44086,
		4086
	],
	"./quote.svg": [
		36145,
		6145
	],
	"./rating1.svg": [
		27717,
		7717
	],
	"./rating2.svg": [
		5286,
		5286
	],
	"./rating3.svg": [
		3319,
		3319
	],
	"./rating4.svg": [
		30488,
		488
	],
	"./replace.svg": [
		1077,
		1077
	],
	"./reward-button.svg": [
		76143,
		6143
	],
	"./reward.svg": [
		16434,
		6434
	],
	"./right-arrow.svg": [
		94991,
		4991
	],
	"./right-indicator.svg": [
		11175,
		1175
	],
	"./rounded-close.svg": [
		50669,
		669
	],
	"./rounded-cross.svg": [
		6565,
		6565
	],
	"./rounded-tick-dark.svg": [
		90037,
		37
	],
	"./rounded-tick.svg": [
		43784,
		3784
	],
	"./search-icon-purple.svg": [
		83562,
		3562
	],
	"./search-icon.svg": [
		51091,
		1091
	],
	"./success-tick.svg": [
		23446,
		3446
	],
	"./suggestion.svg": [
		56563,
		6563
	],
	"./timer.svg": [
		44370,
		4370
	],
	"./total-homework.svg": [
		6642,
		6642
	],
	"./total-subjects.svg": [
		30559,
		559
	],
	"./trash-purple.svg": [
		99610,
		9610
	],
	"./trash.svg": [
		45251,
		5251
	],
	"./unchecked.svg": [
		14093,
		4093
	],
	"./white-tick.svg": [
		16756,
		6756
	],
	"./wrong.svg": [
		35470,
		5470
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 38270;
module.exports = webpackAsyncContext;